<template>
  <div class="md-checkbox" :class="{'md-checkbox-inline': inline}">
    <input
      :id="rawId"
      type="checkbox"
      :value="value"
      :checked="checked"
      :disabled="disabled"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
    <label :for="rawId">
      <slot></slot>
    </label>
  </div>
</template>

<script>
import { v1 as uuid } from 'uuid';

export default {
  props: {
    value: {},
    id: {},
    checked: {
      default: () => false,
    },
    disabled: {
      default: () => false,
    },
    inline: {
      default: () => false,
    },
  },
  data() {
    return {
      rawId: this.id || uuid(),
    };
  },
};
</script>

<style scoped>
.md-checkbox {
  position: relative;
  margin: 4px 0 14px 0;
  text-align: left;
  white-space: nowrap;
}

.md-checkbox.md-checkbox-inline {
  display: inline-block;
}

.md-checkbox label {
  cursor: pointer;
  display: inline-block;
  line-height: 1.25em;
  vertical-align: top;
  clear: both;
  padding-left: 1px;
  font-weight: normal;
}

.md-checkbox label:not(:empty) {
  padding-left: 0.45em;
}

.md-checkbox label:before, .md-checkbox label:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
}

.md-checkbox label:before {
  width: 1.25em;
  height: 1.25em;
  background: white;
  border: 2px solid rgba(0, 0, 0, 0.54);
  border-radius: 0.125em;
  cursor: pointer;
  transition: background 0.3s;
}

.md-checkbox label img {
  width: 1.25em;
  vertical-align: top;
}

.md-checkbox input[type="checkbox"] {
  outline: 0;
  visibility: hidden;
  width: 1.25em;
  margin: 0;
  display: inline;
  font-size: inherit;
}

.md-checkbox input[type="checkbox"]:checked + label:before {
  background: #fee100;
  border: none;
}

.md-checkbox input[type="checkbox"]:checked + label:after {
  transform: translate(0.25em, 0.33654em) rotate(-45deg);
  width: 0.75em;
  height: 0.375em;
  border: 0.125em solid #303A45;
  border-top-style: none;
  border-right-style: none;
}

.md-checkbox input[type="checkbox"]:disabled + label:before {
  border-color: rgba(0, 0, 0, 0.26);
}

.md-checkbox input[type="checkbox"]:disabled:checked + label:before {
  background: rgba(0, 0, 0, 0.26);
}
</style>
